import { isNil } from "lodash-es";

export type IframeColors = Record<ThemableColor, ColorSet | undefined>;

type ThemableColor = "primary";

type ColorSet = {
  r: number;
  g: number;
  b: number;
};

export function isValidColorSet(set: unknown): set is ColorSet {
  if (isNil(set) || typeof set !== "object") {
    return false;
  }

  const { r, g, b } = set as ColorSet;

  if (![r, g, b].every(isValidRgbValue)) {
    return false;
  }

  return true;
}

function isValidRgbValue(color: unknown): boolean {
  if (typeof color !== "number") {
    return false;
  }

  return color >= 0 && color <= 255;
}
